module.exports = __webpack_public_path__ + "static/media/login-bg-2.6a76a7f8.jpg";